<template>
  
<span>

	<Menu/>

	<b-row style="margin-top:125pt">
		<b-col>
			<b-overlay
				:show="true"
				opacity="0"
				variant="white"
				no-center>
				
				<b-carousel>
			
					<b-carousel-slide>

						<template v-slot:img>
							<b-img
							class="d-block img-fluid w-100"
							width="1024"
							height="480"
							:src="require('../../assets/stock/gray-desk-1.jpg')"
							alt="image slot"
							:rounded="true"/>



						</template>

						
						
					

					</b-carousel-slide>

				</b-carousel>

				
				<template v-slot:overlay>
					
					<div 
						class="d-flex h-100 align-items-center justify-content-left"
						style=" color:#FFFFFF">
						
							<p class="pl-3 display-4 d-none d-sm-block">
								See why everyone <br/>loves Principal Task.
							</p>

							
							<p class="pl-3 display-4 d-sm-none">
								See why <br/>everyone <br/>loves<br/> Principal Task.
							</p>

					</div>

				</template>
					
			
				
			
			</b-overlay>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<h1 class="display-4">
				Tour
			</h1>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				<b-row no-gutters>
					
					<b-col 
						md="4" 
						align-self="center"
						order="1"
						order-md="1">
						<b-card-body>
							<b-card-text>

								<h2 class="display-4">
									Dashboard
								</h2>

								<p class="lead">Quickly review your horizon - that which is due soon - 
								as well as helping you to review how productive you've been.</p>
							</b-card-text>

						</b-card-body>
					</b-col>
					
					<b-col 
						md="8"
						order="2"
						order-md="2">
						<b-img
							class="d-block img-fluid w-100 shadow-sm p-3 mb-5 bg-white rounded"
							:src="require('../../assets/tour/dashboard-animated.png')"
							alt="Dashboard"/>
					</b-col>
					
				</b-row>
			</b-card>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				<b-row no-gutters>
					
					<b-col 
						md="4" 
						align-self="center"
						order="1"
						order-md="2">
						<b-card-body>
							<b-card-text>

								<h2 class="display-4">
									Kanban
								</h2>

								<p class="lead">Review and organize your tasks on a kanban board by context, folder, priority, or status.</p>

							</b-card-text>

						</b-card-body>
					</b-col>
					
					<b-col 
						md="8"
						order="2"
						order-md="1">
						<b-img
							class="d-block img-fluid w-100 shadow-sm p-3 mb-5 bg-white rounded"
							:src="require('../../assets/tour/kanban.png')"
							alt="Quick Add"/>
					</b-col>
					
				</b-row>
			</b-card>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				<b-row no-gutters>
					
					<b-col 
						md="4" 
						align-self="center"
						order="1"
						order-md="1">
						<b-card-body>
							<b-card-text>

								<h2 class="display-4">
									Quick Add
								</h2>

								<p class="lead">Short on time?  Add tasks quickly from the top of the page.</p>
							</b-card-text>

						</b-card-body>
					</b-col>
					
					<b-col 
						md="8"
						order="2"
						order-md="1">
						<b-img
							class="d-block img-fluid w-100 shadow-sm p-3 mb-5 bg-white rounded"
							:src="require('../../assets/tour/quick-add-animated.png')"
							alt="Quick Add"/>
					</b-col>
					
				</b-row>
			</b-card>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				<b-row no-gutters>
					
					<b-col 
						md="4" 
						align-self="center"
						order="1"
						order-md="2">
						<b-card-body>
							<b-card-text>

								<h2 class="display-4">
									Detailed Add
								</h2>

								<p class="lead">Stay completely organized by creating a task with all of the important details.</p>
							</b-card-text>

						</b-card-body>
					</b-col>
					
					<b-col 
						md="8"
						order="2"
						order-md="1">
						<b-img
							class="d-block img-fluid w-100 shadow-sm p-3 mb-5 bg-white rounded"
							:src="require('../../assets/tour/detailed-add-animated.png')"
							alt="Quick Add"/>
					</b-col>
					
				</b-row>
			</b-card>
		</b-col>
	</b-row>

	
	
	<b-row align-h="around" cols="12">
		<b-col cols="12"
			style="text-align:center;">
			<b-button :to="{name: 'signup', params: {action: 'signup'}}" 
                            variant="success" class="mt-3">Get Started</b-button>
		</b-col>
	</b-row>

</span>
</template>
<script>

	import Menu from '@/components/menus/Menu4.vue'
	import features from '@/mixins/features'

	export default {
		name: 'Tour4',
		metaInfo() {
			return {
				title: 'Principal Task | Tour',
				meta: [
					{
						name: 'description',
						content: 'Highlights of the features and benefits of Principal Task.'
					},
					{
						property: 'og:description',
						content: 'Highlights of the features and benefits of Principal Task.'
					},
					{
						property: 'og:image',
						content: 'http://www.principaltask.com/img/PTLogo-Cropped-1.fafd2068.png'
					},
					{
						property: 'og:title',
						content: 'Principal Task | Tour'
					},
					{
						property: 'og:type',
						content: 'website'
					},
					{
						name: 'twitter:card',
						content: 'summary_large_image'
					},
					{
						name: 'twitter:description',
						content: 'Highlights of the features and benefits of Principal Task.'
					},
					{
						property: 'twitter:image',
						content: 'https://www.principaltask.com/img/PTLogo-Cropped-1.fafd2068.png'
					},
					{
						name: 'twitter:site',
						content: '@PrincipalTask'
					},
					{
						name: 'twitter:title',
						content: 'Principal Task | Tour'
					},
				]
			}
		},
		components: {
            Menu
		},
		mixins: [
			features,
		],
		props: {
		},
		data () {
			return {
				
			}
		},
		methods: {
			
		},    

}
</script>